import cx from 'classnames';
import React from 'react';
import { Button } from '../Button/Button';
import { Icon } from '../Icon';

export interface SortProps {
	className?: string;
	descWcagLabel: string;
	descDisabled?: boolean;
	descOnClick: () => void;
	ascWcagLabel: string;
	ascDisabled?: boolean;
	ascOnClick: () => void;
}

export const SortArrows = ({
	className,
	descWcagLabel,
	descDisabled,
	descOnClick,
	ascWcagLabel,
	ascDisabled,
	ascOnClick,
}: SortProps) => (
	<span className={cx('sort-arrows', className && className)}>
		<Button
			aria-label={descWcagLabel}
			color="primary"
			type="base"
			size="xs"
			isDisabled={descDisabled ?? false}
			onClick={descOnClick}
			iconStart={
				<Icon
					type="components"
					name="chevron-down"
				/>
			}
		/>
		<Button
			aria-label={ascWcagLabel}
			color="primary"
			type="base"
			size="xs"
			isDisabled={ascDisabled ?? false}
			onClick={ascOnClick}
			iconStart={
				<Icon
					type="components"
					name="chevron-up"
				/>
			}
		/>
	</span>
);
